// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dL-z","smallCardRow":"eL-z","largeCardRow":"fL-z","productSearchRow":"gL-z","curatedRow":"hL-z"};